import type { ReactNode } from "react";
import { subtitleCopy } from "../../iris/maker-language";
import { CapricaIris, type IrisMode } from "../CapricaIris";

/** Iris on the screen: her iris, which pulses while she thinks; tap it to let her stop talking. */
export function IrisPresence({ mode, level, thinking, listening, revealing, stop, corner }: {
  mode: IrisMode;
  level: { current: number };
  thinking: boolean;
  listening: boolean;
  revealing: boolean;
  stop: () => void;
  corner?: ReactNode;
}) {
  return (
    <div className={`subtitle-presence${thinking ? " pulse" : ""}`}>
      <button type="button" className="talk-iris-button" aria-label={revealing ? "Let Iris stop talking" : "Iris"} disabled={!revealing} onClick={stop}>
        <CapricaIris mode={mode} level={level} size={84} />
      </button>
      <span className="subtitle-name">Iris</span>
      {listening && <span className="subtitle-listening" role="status">{subtitleCopy().listening}</span>}
      {corner && <div className="subtitle-corner">{corner}</div>}
    </div>
  );
}
